export default {
  DOWNLOAD: 'Télécharger',
  PROCESSING: 'Traitement',
  GENERAL_EVENT_INFO: 'Informations générales sur l’événement',
  EVENT_DETAILS: 'Détails de l’événement',
  GENERATE_NEW: 'Générer un nouveau',
  REPORT_NOT_GENERATED:
    'Votre rapport n’a pas encore été généré ou aucun prospect n’a été capturé jusqu’à présent. Veuillez réessayer après un certain temps.',
  REPORT_DOWNLOADED: 'Rapport téléchargé avec succès',
  DOWNLOAD_REPORT: 'Télécharger le rapport',
  LAST_GENERATED: 'Dernier rapport généré le',
  DOWNLOAD_REPORT_INFO: 'La génération d’un nouveau rapport peut prendre un certain temps, veuillez donc garder cet onglet ouvert.'
}
